import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import EstimatesDetails from './EstimatesDetails';
import RaisedForDetails from './RaisedForDetails';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';

const OpenAnomalyView = () => {
  const isLoading = useSelector(
    (state: RootState) => state?.anomalyTracker?.anomalyDetails?.loading
  );

  if (isLoading)
    return (
      <div className="h-full flex items-center justify-center">
        <CircularLoaderIcon size="lg" />
      </div>
    );

  return (
    <>
      <EstimatesDetails descriptionClass="max-w-[80%]" />
      <RaisedForDetails />
    </>
  );
};

export default OpenAnomalyView;
